import en from "./en";
import es from "./es";
import pt from "./pt";
const languages = {
  en,
  es,
  pt,
};
export default languages;
